import gql from 'graphql-tag';
import React, { Fragment } from 'react';
import { useState } from 'react';
import { withApollo } from 'react-apollo';
import { Redirect } from 'react-router';
import ReactCodeInput from 'react-verification-code-input';
import Loading from '../shared/Loading';

const Verification = ({
  curPhone,
  client,
  country,
  authyId,
  toggleValidated,
  curFirst,
  curLast,
  curEmail,
  curPassword,
  curDrive,
  curHear,
  curCode,
  curOther
}) => {
  const [curVeriCode, setVeriCurCode] = useState();
  const [verified, setVerified] = useState();
  const [loading, setLoading] = useState();
  const [newCreatedUser, setNewCreatedUser] = useState();

  const triggerCodeChange = e => {
    setVeriCurCode(e);
  };

  const toggleVerified = () => {
    setVerified(!verified);
  };

  const VERIFY_DEVICE = gql`
    mutation VerifyDevice(
      $authyId: String!
      $token: String!
      $mobile: String
    ) {
      verifyDevice(authyId: $authyId, token: $token, mobile: $mobile) {
        verified
        user {
          id
        }
        error
      }
    }
  `;

  const handleCodeSubmit = e => {
    // e.preventDefault();
    client
      .mutate({
        mutation: VERIFY_DEVICE,
        variables: {
          authyId: authyId,
          token: e,
          mobile: curPhone
        }
      })
      .then(res => {
        console.log(res.data);
        if (res.data.verifyDevice.verified) {
          handleSignUp();
        } else if (res.data.verifyDevice.error) {
          setVerified(false);
        }
      });
  };

  const SEND_VERIFICATION = gql`
    mutation SendVerificationCode(
      $countryCode: String!
      $mobile: String!
      $email: String!
    ) {
      sendVerificationCode(
        countryCode: $countryCode
        mobile: $mobile
        email: $email
      ) {
        sent
        error
        authyId
      }
    }
  `;

  const resendCode = () => {
    // e.preventDefault();
    client
      .mutate({
        mutation: SEND_VERIFICATION,
        variables: {
          countryCode: '1',
          mobile: curPhone,
          email: curEmail
        }
      })
      .then(res => {
        console.log(res.data);
        if (res.data.sendVerificationCode.sent) {
          console.log('sms verification code sent');
        } else if (res.data.error) {
          console.log('send verification error!');
        }
      });
  };

  const SIGN_UP = gql`
    mutation CreateUserFromWebsite(
      $params: UserAttributes!
      $verifyDevice: Boolean
    ) {
      createUserFromWebsite(params: $params, verifyDevice: $verifyDevice) {
        user {
          id
          firstName
          lastName
          email
          mobile
        }
        errors {
          path
          message
        }
      }
    }
  `;

  const handleSignUp = e => {
    // e.preventDefault();
    setLoading(true);
    client
      .mutate({
        mutation: SIGN_UP,
        variables: {
          params: {
            firstName: curFirst,
            lastName: curLast,
            email: curEmail,
            password: curPassword,
            mobile: curPhone,
            cityId: curDrive,
            referralSource: curHear,
            referrerCode: curCode,
            otherReferralSources: curOther
          },
          verifyDevice: false
        }
      })
      .then(res => {
        console.log(res.data.createUserFromWebsite.user);
        if (!res.data.createUserFromWebsite.errors) {
          setLoading(false);
          setNewCreatedUser(res.data.createUserFromWebsite.user);
          toggleVerified();

          console.log('user created!');
        } else {
          setLoading(false);
          console.log('user create error!');
        }
      });
  };

  return verified ? (
    <Redirect
      to={{
        pathname: `/signup/download`,
        user: newCreatedUser,
        country: country
      }}
    />
  ) : (
    <Fragment>
      {loading ? (
        <Loading size="3x" />
      ) : (
        <div className="signup-form-container" style={{ width: 380 }}>
          <div className="verification-box">
            <div className="download-title" style={{ margin: '0' }}>
              Confirm your number
            </div>

            <div className="veri-text">
              Enter the 6 digit code Autzu sent to {curPhone}
            </div>
            <ReactCodeInput
              onChange={triggerCodeChange}
              onComplete={handleCodeSubmit}
              fieldHeight="40px"
            />
            {verified === false && (
              <div style={{ color: '#ff0000' }}>Invalid code</div>
            )}
            <div style={{ marginTop: '16px' }}>
              <span style={{ marginRight: '8px' }}>
                Didn't get a text?{' '}
              </span>
              <span
                style={{ color: '#128dff', cursor: 'pointer' }}
                onClick={resendCode}>
                Send again
              </span>
            </div>
            <div>
              <span style={{ marginRight: '8px' }}>Change number? </span>
              <span
                style={{ color: '#128dff', cursor: 'pointer' }}
                onClick={toggleValidated}>
                Go back
              </span>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default withApollo(Verification);



// WEBPACK FOOTER //
// ./src/components/NewSignUp/Verfication.js